module.exports = __webpack_public_path__ + "media/images/course_section_0-6f5ee811a67bc7bf2cacfaa13efbe780.png";